
/* global EventSource */
define('jsx!components/min-e24-box/main',['jquery', 'underscore', 'react', 'lib'], function($, _, React, lib) {
    'use strict';

    var PureRenderMixin = React.addons.PureRenderMixin;

    var MinE24Box = React.createClass({displayName: "MinE24Box",
        getInitialState: function() {
            return {
                results: [],
                limit: 0,
            };
        },

        componentDidMount: function() {
            if (lib.isMobile()) {
                this.state.limit = 2;
            } else {
                this.state.limit = 3;
            }
            this.getSSEArticles();
        },

        setResultState: function(data) {
            this.setState({
                results: data,
            });
        },

        getSSEArticles: function() {
            var BorsSocket = new EventSource('//sse.e24.no/min-e24?getcache=1');
            BorsSocket.addEventListener('message', _.bind(function(event) {
                var data;
                try {
                    data = JSON.parse(event.data);
                } catch(e) {
                    throw e;
                }
                if (data) {
                    this.setResultState(data);
                }
            }, this));
        },

        createMarkup: function(html) {
            return {__html: html};
        },

        getTimeDifference: function(publishedTime) {
            var timeString = '';
            var currentTime = new Date();
            var timeDiff = Math.abs(currentTime - publishedTime);
            var minutesDiff = parseInt(timeDiff / 1000 / 60);
            var hours = parseInt(minutesDiff / 60);

            if (hours > 0) {
                timeString = timeString.concat(hours).concat(' TIME');
                if (hours > 1) {
                    timeString = timeString.concat('R');
                }
            } else {
                timeString = timeString.concat(minutesDiff).concat(' MIN');
            }
            return timeString;
        },

        renderSpinner: function() {
            return React.createElement("div", {className: "e24-spinner"}, 
                React.createElement("div", {className: "double-bounce1"}), 
                React.createElement("div", {className: "double-bounce2"})
            );
        },

        renderArticles: function() {
            var cleanResults = this.state.results;
            var resultBody = [];
            var imageBaseUrl = '//gfx.omni.se/images/';

            if (cleanResults.length > 0) {
                for (var i = 0; i < Math.min(cleanResults.length, this.state.limit); i++) {
                    var articleUrl = '//min.e24.no/a/';
                    articleUrl = articleUrl.concat(cleanResults[i].article_id);
                    var headline = cleanResults[i].title.value;
                    var category = cleanResults[i].story_vignette.title;
                    var imageUrl = '';
                    var publishedTime;
                    var currentTime = new Date();
                    var timeString = '';
                    var ingress = cleanResults[i].main_text.paragraphs[0].text.value;
                    var splitIngress = ingress.split(' ');

                    if ((category.length + splitIngress[0].length) > 30) {
                        ingress = '<br>' + ingress;
                    }

                    for (var j = 0; j < cleanResults[i].resources.length; j++) {
                        if (cleanResults[i].resources[j].type && cleanResults[i].resources[j].type === "Image") {
                            imageUrl = imageBaseUrl.concat(cleanResults[i].resources[j].image_asset.id);
                            imageUrl = imageUrl.concat('?w=100');
                            break;
                        }
                        if (cleanResults[i].resources[j].data
                            && cleanResults[i].resources[j].data.type
                            && cleanResults[i].resources[j].data.type === "video") {
                            imageUrl = cleanResults[i].resources[j].data.image;
                            break;
                        }
                    }

                    for (var j = 0; j < cleanResults[i].resources.length; j++) {
                        if (cleanResults[i].resources[j].type && cleanResults[i].resources[j].type === "Byline") {
                            // publishedTime = new Date(cleanResults[i].resources[j].published);
                            publishedTime = new Date(cleanResults[i].meta.changes.published);
                            break;
                        }
                    }
                    timeString = this.getTimeDifference(publishedTime);

                    resultBody.push(
                        React.createElement("li", {className: "article", key: cleanResults[i].article_id}, 
                            React.createElement("a", {className: "article-link", href: articleUrl}, 
                                React.createElement("img", {src: imageUrl}), 
                                React.createElement("b", {className: "title"}, headline), 
                                React.createElement("p", {className: "text"}, 
                                    React.createElement("span", {className: "category"}, category), 
                                    React.createElement("span", {
                                        className: "ingress", 
                                        dangerouslySetInnerHTML: this.createMarkup(ingress)
                                    }), 
                                    React.createElement("span", {className: "fade"}), 
                                    React.createElement("span", {className: "time"}, timeString)
                                )
                            )
                        )
                    );
                }
            } else {
                var className = 'loading';
                if (lib.isMobile()) {
                    className = className.concat(' loading-mobile');
                }
                resultBody.push(
                    React.createElement("li", {className: className, key: "loading-spinner"}, 
                        React.createElement("a", {className: "article-link", href: ""}, 
                            this.renderSpinner()
                        )
                    )
                );
            }

            var readmore = 'Les mer >';

            return (
                React.createElement("div", {className: "min-e24-article-container"}, 
                    React.createElement("div", {className: "min-e24-top"}, 
                        React.createElement("div", {className: "min-e24-icon"}, 
                            React.createElement("img", {src: "//static.e24.no/images/min-e24/180-x-180-copy.png", 
                                srcSet: "//static.e24.no/images/min-e24/180-x-180-copy@2x.png 2x," + ' ' +
                                    "//static.e24.no/images/min-e24/180-x-180-copy@3x.png 3x"}
                            )
                        ), 
                        React.createElement("div", {className: "min-e24-headers"}, 
                            React.createElement("p", {className: "min-e24-latest"}, "Siste nytt"), 
                            React.createElement("p", null, "fra minE24 - last ned appen nå!")
                        ), 
                        this.renderDownloadContainer()
                    ), 
                    React.createElement("ul", null, 
                        resultBody, 
                        React.createElement("li", null, 
                            React.createElement("p", {className: "min-e24-read-more", key: "min-e24-read-more"}, 
                                React.createElement("a", {href: "//e24.no/min-E24"}, readmore)
                            )
                        )
                    )
                )
            );
        },

        renderDownloadContainer: function() {
            return (
                React.createElement("div", {className: "min-e24-button-container"}, 
                    React.createElement("a", {href: "https://itunes.apple.com/us/app/mine24-nyheter-om-%C3%B8konomi/id400428988?mt=8", className: "min-e24-button"}, 
                        React.createElement("img", {src: "//static.e24.no/images/min-e24/appstore.svg"})
                    ), 
                    React.createElement("a", {href: "market://details?id=no.e24dinepenger.e24&hl=no", className: "min-e24-button"}, 
                        React.createElement("img", {src: "//static.e24.no/images/min-e24/fill-1.svg"})
                    )
                )
            );
        },

        render: function() {
            return (
                React.createElement("div", {className: "min-e24-widget"}, 
                    React.createElement("div", null, 
                        this.renderArticles()
                    )
                )
            );
        },
    });

    return function renderComponent(element, config) {
        if (!element) {
            return;
        }
        config = config || {};
        React.render(React.createElement(MinE24Box, React.__spread({},  config)), element);
    };
});

